import type * as React from 'react'
import * as Sentry from '@sentry/react'

import type { JSX } from 'react'

function ErrorBoundary({
  children,
}: {
  children: React.ReactNode
}): JSX.Element {
  return (
    <Sentry.ErrorBoundary fallback={<p role="alert">Something went wrong.</p>}>
      {children}
    </Sentry.ErrorBoundary>
  )
}

export default ErrorBoundary
